import React from 'react';
import { MinusCircle, AlertTriangle } from 'lucide-react';

const WithdrawalsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  frequencyOptions 
}) => {
  if (!formData.withdrawals) return null;

  return (
    <div className="mb-6 bg-orange-50 dark:bg-orange-900/20 p-4 rounded-lg border border-orange-200 dark:border-orange-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <MinusCircle className="w-5 h-5 mr-2 text-orange-500" />
        Частичные снятия
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма снятия */}
        <div>
          <label htmlFor="withdrawalAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сумма снятия
          </label>
          <input
            type="text"
            id="withdrawalAmount"
            name="withdrawalAmount"
            value={formData.withdrawalAmount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.withdrawalAmount ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.withdrawalAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.withdrawalAmount}
            </p>
          )}
        </div>

        {/* Периодичность снятий */}
        <div>
          <label htmlFor="withdrawalFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Периодичность
          </label>
          <select
            id="withdrawalFrequency"
            name="withdrawalFrequency"
            value={formData.withdrawalFrequency}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.withdrawalFrequency ? 'input-error' : ''}`}
          >
            {frequencyOptions.map((frequency) => (
              <option key={frequency.id} value={frequency.id}>
                {frequency.name}
              </option>
            ))}
          </select>
          {errors.withdrawalFrequency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.withdrawalFrequency}
            </p>
          )}
        </div>

        {/* Месяц начала снятий */}
        <div>
          <label htmlFor="withdrawalStartMonth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Начать с месяца
          </label>
          <input
            type="text"
            id="withdrawalStartMonth"
            name="withdrawalStartMonth"
            value={formData.withdrawalStartMonth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.withdrawalStartMonth ? 'input-error' : ''}`}
            placeholder="Номер месяца"
          />
          {errors.withdrawalStartMonth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.withdrawalStartMonth}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-orange-100 dark:bg-orange-900/30 p-3 rounded-lg border border-orange-200 dark:border-orange-800">
        <div className="flex items-start">
          <AlertTriangle className="w-5 h-5 text-orange-600 dark:text-orange-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-orange-700 dark:text-orange-300 mb-1">
              Внимание при снятиях
            </h4>
            <p className="text-xs text-orange-600 dark:text-orange-400">
              Частичные снятия средств со вклада могут снизить его доходность. Некоторые банки при частичных снятиях снижают процентную ставку или применяют штрафы. Проверяйте условия банка перед снятием.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalsSection;